import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker";
import { TextField } from "@mui/material";
import { parseISO, format } from "date-fns";
import { it } from "date-fns/locale";
import { driverDrawer } from "../../pages/fleetAndRoute/style";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { Vehicle } from "../../types/vehicles";

interface Props {
  vehicleData: { firstRegistrationDate?: string; firstRegistrationDate_lock?: boolean };
  handleChange: (key: string, value: string | undefined) => void;
  errors: { firstRegistrationDate?: boolean };
  selectedVehicle: any;
  disabled: boolean;
}

const VehicleDatePicker: React.FC<Props> = ({
  vehicleData,
  handleChange,
  errors,
  selectedVehicle,
  disabled
}) => {
  const parsedDate = vehicleData.firstRegistrationDate
    ? parseISO(vehicleData.firstRegistrationDate)
    : null;
  const isDisabled = () => {
    if (!selectedVehicle) return false;
    if (selectedVehicle.source === "VLM") return true;
    if (selectedVehicle.source === "EAM") {
      return vehicleData.firstRegistrationDate_lock || disabled;
    }
    return false;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
       <DesktopDatePicker
         disabled={isDisabled()}
         inputFormat="dd/MM/yyyy"
         value={parsedDate}
         onChange={(date) => {
           if (!isDisabled()) {
             handleChange(
               "firstRegistrationDate",
               date ? date.toLocaleString("sv-SE").replace(" ", "T") : undefined
             );
           }
         }}
         views={["year", "month", "day"]}
         renderInput={(params) => (
           <TextField
             {...params}
             fullWidth
             disabled={isDisabled()}
             error={Boolean(errors.firstRegistrationDate)}
             helperText={errors.firstRegistrationDate ? "Data non valida" : ""}
             sx={{
               "& .MuiInputBase-root": { 
                 height: 41,
                 "& fieldset": {
                   borderColor: "gray"
                 }
               },
               "& .MuiTypography-root": { fontSize: "0.85rem" },
             }}
           />
         )}
       />
    </LocalizationProvider>
  );
};

export default VehicleDatePicker;
